import { Link } from "react-router-dom";

const footerLinks = [
  { label: "电影", to: "/category/movie" },
  { label: "电视剧", to: "/category/tv" },
  { label: "综艺", to: "/category/variety" },
  { label: "搜索", to: "/search" },
  { label: "关于我们", to: "/about" },
];

export default function Footer() {
  return (
    <footer className="mt-16 bg-primary-950 text-background-100">
      <div className="mx-auto grid w-full max-w-[1320px] grid-cols-1 gap-8 px-4 py-12 md:grid-cols-4 md:px-6">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-mickey-fill text-lg" />
            </span>
            <span className="font-heading text-lg font-extrabold text-background-50">
              蘑菇<span className="text-primary-300">视频</span>
            </span>
          </div>
          <p className="mt-4 max-w-md text-sm leading-relaxed text-background-200/80">
            蘑菇视频是面向影视爱好者的高清内容平台，汇聚电影、电视剧与综艺节目，提供便捷的浏览、筛选与编辑精选推荐，让每一次观影都更轻松愉快。
          </p>
          <div className="mt-5 flex items-center gap-3">
            {["ri-wechat-line", "ri-weibo-line", "ri-douban-line", "ri-mail-line"].map((icon) => (
              <span
                key={icon}
                className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50/10 text-background-100 transition-colors hover:bg-primary-500 hover:text-background-50 cursor-pointer"
              >
                <i className={`${icon} text-lg`} />
              </span>
            ))}
          </div>
        </div>

        <div>
          <h4 className="font-heading text-sm font-semibold text-background-50">内容导航</h4>
          <ul className="mt-4 space-y-2.5 text-sm">
            {footerLinks.map((link) => (
              <li key={link.to}>
                <Link
                  to={link.to}
                  className="text-background-200/80 transition-colors hover:text-primary-300"
                >
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-heading text-sm font-semibold text-background-50">友情链接</h4>
          <ul className="mt-4 space-y-2.5 text-sm">
            <li><span className="text-background-200/80">影视资讯站</span></li>
            <li><span className="text-background-200/80">电影资料馆</span></li>
            <li><span className="text-background-200/80">综艺观察</span></li>
            <li><span className="text-background-200/80">剧集评分榜</span></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-background-50/10">
        <div className="mx-auto flex w-full max-w-[1320px] flex-col gap-2 px-4 py-5 text-xs text-background-200/70 sm:flex-row sm:items-center sm:justify-between md:px-6">
          <p>© 2025 蘑菇视频 版权所有 · 本站内容为演示示例，仅供学习交流使用</p>
          <p>本站不提供任何真实视频播放服务，播放按钮为演示交互</p>
        </div>
      </div>
    </footer>
  );
}